<script>
export default {
    props: {
        width: {
            type: Number,
            default: 100,
            description: 'Value between 0 and 100. Converted to percentage.'
        }
    }
}
</script>

<template>
    <div class="sust-card" :style="{width: `${width}%`}">
        <slot></slot>
    </div>
</template>

<style lang='scss' scoped>
    .sust-card {
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-items: flex-start;
        box-shadow: 0 .25em .6em .1em gray;
        border-radius: 1em;
        background-color: whitesmoke;
        padding: .5em;
        margin-bottom: 1em;
    }
</style>